"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTooltipVisibility = void 0;
const react_1 = __importDefault(require("react"));
const useTooltipVisibility = () => {
    const [visible, setVisible] = react_1.default.useState(false);
    const timeoutRef = react_1.default.useRef(null);
    const showTooltip = react_1.default.useCallback(() => {
        timeoutRef.current = setTimeout(() => {
            setVisible(true);
        }, 200);
    }, []);
    const hideTooltip = react_1.default.useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setVisible(false);
    }, []);
    react_1.default.useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);
    return { visible, showTooltip, hideTooltip };
};
exports.useTooltipVisibility = useTooltipVisibility;
//# sourceMappingURL=useTooltipVisibility.js.map